import * as React from 'react';
import styled from 'styled-components';
import { CopyToClipboard } from 'react-copy-to-clipboard';

interface IContent {
  signature: any;
  showHelp?: boolean;
}

export const Content: React.FC<IContent> = ({
  children,
  showHelp,
  signature,
}) => {
  return (
    <StyledContent>
      {!showHelp ? (
        <StyledSignatureTab>
          <StyledSignature>
            {signature && signature.urltag ? (
              <Signature id="signature">
                <table
                  style={{
                    backgroundColor: '#ffffff',
                    color: '#000000',
                    width: '100% !important',
                    borderCollapse: 'separate',
                  }}
                >
                  <tbody>
                    {signature && signature.officeName ? (
                      <tr>
                        <td style={{ paddingBottom: '12px' }}>
                          <img
                            style={{ width: '100%' }}
                            src={`https://staging-pmsignatur.reeltime.no/logo?office_name=${signature.officeName.toUpperCase()}`}
                          />
                        </td>
                      </tr>
                    ) : null}
                    <tr>
                      <td>
                        <p
                          style={{
                            fontFamily: 'Arial',
                            fontSize: '11px',
                            lineHeight: '28px',
                            margin: 0,
                          }}
                        >
                          Med vennlig hilsen
                        </p>
                      </td>
                    </tr>
                    {signature && signature.name ? (
                      <tr>
                        <td>
                          <p
                            style={{
                              fontFamily: 'Times New Roman',
                              fontSize: '14px',
                              lineHeight: '14px',
                              margin: 0,
                            }}
                          >
                            {signature.name}
                          </p>
                        </td>
                      </tr>
                    ) : null}
                    {signature && signature.title ? (
                      <tr>
                        <td>
                          <p
                            style={{
                              fontFamily: 'Arial',
                              fontSize: '11px',
                              lineHeight: '14px',
                              margin: 0,
                            }}
                          >
                            {signature.title}
                          </p>
                        </td>
                      </tr>
                    ) : null}
                    {signature && signature.phone ? (
                      <tr style={{ marginTop: '10px' }}>
                        <td>
                          <p
                            style={{
                              fontFamily: 'Arial',
                              fontSize: '11px',
                              lineHeight: '14px',
                              margin: 0,
                            }}
                          >
                            {signature.phone}
                          </p>
                        </td>
                      </tr>
                    ) : null}
                    {signature && signature.address1 ? (
                      <tr>
                        <td>
                          <p
                            style={{
                              margin: 0,
                              fontFamily: 'Arial',
                              fontSize: '11px',
                              color: '#010000',
                            }}
                          >
                            {signature.address1}
                          </p>
                        </td>
                      </tr>
                    ) : null}
                    {signature && signature.address2 ? (
                      <tr>
                        <td>
                          <p
                            style={{
                              margin: 0,
                              fontFamily: 'Arial',
                              fontSize: '11px',
                              color: '#010000',
                            }}
                          >
                            {signature.address2}
                          </p>
                        </td>
                      </tr>
                    ) : null}
                    {signature && signature.urltag ? (
                      <tr>
                        <td style={{ padding: '10px 0' }}>
                          <a
                            style={{
                              margin: '0',
                              fontFamily: 'Arial',
                              fontSize: '11px',
                              color: '#010000',
                            }}
                            href={`https://privatmegleren.no/${signature.urltag}`}
                            target="_blank"
                          >{`https://privatmegleren.no/${signature.urltag}`}</a>
                        </td>
                      </tr>
                    ) : null}
                    {signature && signature.custom ? (
                      <tr>
                        <td>
                          <p
                            style={{
                              fontFamily: 'Arial',
                              fontSize: '14px',
                              lineHeight: '18px',
                              margin: 0,
                            }}
                          >
                            {signature.custom}
                          </p>
                        </td>
                      </tr>
                    ) : null}
                    <tr>
                      <td style={{ marginTop: '20px' }}></td>
                    </tr>
                    <tr>
                      <td>
                        <p
                          style={{
                            fontFamily: 'Arial',
                            fontSize: '9px',
                            lineHeight: 3,
                            margin: 0,
                          }}
                        >
                          NORDEAS EIENDOMSMEGLERKJEDE
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ marginBottom: '10px', float: 'left' }}>
                        {signature && signature.instagram ? (
                          <>
                            <a href={signature.instagram}>
                              <img
                                width="12"
                                height="12"
                                style={{
                                  border: '0 none',
                                  outline: 0,
                                }}
                                src="https://cdn.reeltime.no/pm_assets/signatur/instagram.png"
                              />
                            </a>
                            <span
                              style={{
                                marginRight: '10px',
                              }}
                            ></span>
                          </>
                        ) : null}
                        {signature && signature.facebook ? (
                          <>
                            <a
                              href={signature.facebook}
                              style={{ marginLeft: '1px' }}
                            >
                              <img
                                width="12"
                                height="12"
                                style={{ border: '0 none', outline: 0 }}
                                src="https://cdn.reeltime.no/pm_assets/signatur/facebook.png"
                              />
                            </a>
                            <span style={{ marginRight: '10px' }}></span>
                          </>
                        ) : null}
                        {signature && signature.linkedin ? (
                          <>
                            <a
                              href={signature.linkedin}
                              style={{ marginLeft: '1px' }}
                            >
                              <img
                                width="12"
                                height="12"
                                style={{ border: '0 none', outline: 0 }}
                                src="https://cdn.reeltime.no/pm_assets/signatur/linkedin.png"
                              />
                            </a>
                            <span style={{ marginRight: '10px' }}></span>
                          </>
                        ) : null}
                      </td>
                    </tr>
                    {signature && signature.path ? (
                      <tr>
                        <td>
                          <a
                            style={{
                              fontFamily: 'Arial',
                              fontSize: '11px',
                              lineHeight: '14px',
                              margin: 0,
                              color: '#000',
                            }}
                            href={`https://privatmegleren.no${signature.path}/vcard`}
                          >
                            <img
                              width="17"
                              height="12"
                              src="https://cdn.reeltime.no/pm_assets/signatur/dl_vcard.png"
                              style={{ marginRight: '5px' }}
                            ></img>
                            Last ned visittkort
                          </a>
                        </td>
                      </tr>
                    ) : null}
                    <tr>
                      <td>
                        {signature && signature.showLink ? (
                          <table
                            cellPadding="0"
                            cellSpacing="0"
                            style={{
                              width: '325px',
                              height: '325px',
                              margin: 0,
                              marginTop: '20px',
                              borderCollapse: 'collapse',
                              background: '#231F20',
                              tableLayout: 'fixed',
                            }}
                          >
                            <tbody>
                              <tr>
                                <td colSpan={2}>
                                  <img
                                    src="https://cdn.reeltime.no/pm_assets/signatur/mbk3_1.png"
                                    alt=""
                                    style={{ margin: 0, width: '100%' }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <a
                                    href="https://itunes.apple.com/no/app/mitt-boligkj%C3%B8p/id1328257724?mt=8"
                                    target="_blank"
                                  >
                                    <img
                                      src="https://cdn.reeltime.no/pm_assets/signatur/mbk3_2.png"
                                      width="163"
                                      height="61"
                                      alt=""
                                    />
                                  </a>
                                </td>
                                <td>
                                  <a
                                    href="https://play.google.com/store/apps/details?id=no.pm.boligkjop"
                                    target="_blank"
                                  >
                                    <img
                                      src="https://cdn.reeltime.no/pm_assets/signatur/mbk_3_3.png"
                                      width="163"
                                      height="61"
                                      alt=""
                                    />
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        ) : null}
                      </td>
                    </tr>
                    <tr style={{ width: '250px' }}>
                      {signature && signature.showValuation ? (
                        <td>
                          <a href="https://privatmegleren.no/verdivurdering/signatur">
                            <img
                              src="https://cdn.reeltime.no/pm_assets/signatur/signatur_verdivurdering4.jpg"
                              alt=""
                              style={{ margin: 0, width: '250px' }}
                            />
                          </a>
                        </td>
                      ) : null}
                    </tr>
                    <tr style={{ width: '250px' }}>
                      {signature && signature.showSale ? (
                        <td>
                          <a href="https://privatmegleren.no/kontorer/inarheten">
                            <img
                              src="https://cdn.reeltime.no/pm_assets/signatur/signatur_selge4.jpg"
                              alt=""
                              style={{ margin: 0, width: '250px' }}
                            />
                          </a>
                        </td>
                      ) : null}
                    </tr>
                    <tr>
                      <td>
                        <p
                          style={{
                            fontFamily: 'Arial',
                            fontSize: '11px',
                            lineHeight: '14px',
                            margin: 0,
                          }}
                        >
                          <b style={{}}>NB!</b>
                          <span>
                            {' '}
                            Ikke send sensitive personopplysninger ukryptert via
                            epost.
                          </span>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Signature>
            ) : (
              <p style={{ marginTop: '20px' }}>Velg kontor fra listen..</p>
            )}
          </StyledSignature>
        </StyledSignatureTab>
      ) : (
        <StyledSignatureHelp>
          <HelpWrapper>
            <HelpCol>
              <div className="help-header">Outlook</div>
              <ul>
                <li>Fyll ut feltene</li>
                <li>Velg kontor</li>
                <li>
                  Marker signaturen med musen slik at alle elementene blir
                  markert med blått.
                </li>
                <li>Høyreklikk og trykk "Kopier"</li>
                <li>Start Outlook</li>
                <li>Trykk "Ny e-post" øverst til venstre.</li>
                <li>Trykk «Signatur» deretter «Signaturer…»</li>
                <li>Trykk «Ny» og skriv inn navn på signaturen.</li>
                <li>
                  Høyreklikk i det store feltet som heter "rediger signatur" og
                  deretter trykk "Lim inn"
                </li>
                <li>
                  For at signaturen skal fungere som standardsignatur, må du til
                  høyre i vinduet under "Velg standardsignatur" velge din
                  "E-postkonto", og under "Nye meldinger" og
                  "Svar/videresendinger" velge navnet på signaturen du har
                  laget. Trykk deretter OK
                </li>
              </ul>
            </HelpCol>
            <HelpCol>
              <div className="help-header">Apple Mail</div>
              <ul>
                <li>Fyll ut feltene</li>
                <li>Velg kontor</li>
                <li>
                  Marker signaturen med musen slik at alle elementene blir
                  markert med blått.
                </li>
                <li>Høyreklikk og trykk "Kopier"</li>
                <li>Trykk «Mail» deretter «Valg»</li>
                <li>Trykk på «Signaturer»</li>
                <li>Trykk på + og skriv inn navn på signaturen</li>
                <li>
                  Høyreklikk i det store hvite feltet og deretter trykk "Lim
                  inn".
                </li>
                <li>Lukk vindu</li>
              </ul>
            </HelpCol>
            <HelpCol>
              <div className="help-header">iPhone/iPad</div>
              <ul>
                <li>Fyll ut feltene</li>
                <li>Velg kontor</li>
                <li>
                  Marker signaturen med musen slik at alle elementene blir
                  markert med blått.
                </li>
                <li>Høyreklikk og trykk "Kopier"</li>
                <li>Gå til Innstillinger fra hovedskjermen</li>
                <li>Velg "Mail, kontakter, kalendere"</li>
                <li>
                  Velg "Signatur", klikk i det hvite feltet og velg lim inn
                </li>
                <li>
                  Rist på telefonen, du vil da få opp en dialog som heter "Angre
                  endring av egenskaper", velg "Angre".
                </li>
                <li>Signaturen din er nå lagret</li>
                <li>
                  <a
                    href="http://www.imore.com/how-create-html-rich-emails-signatures-your-iphone-and-ipad"
                    target="_blank"
                  >
                    Les mer her
                  </a>
                </li>
              </ul>
            </HelpCol>
          </HelpWrapper>
        </StyledSignatureHelp>
      )}
    </StyledContent>
  );
};

const HelpWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
`;

const HelpCol = styled.div`
  display: flex;
  flex-flow: column;
  box-sizing: border-box;
  width: 50%;
  float: left;
  padding-left: 0.83333%;
  padding-right: 0.83333%;
  margin-bottom: 1.66667%;
  .help-header {
    position: relative;
    font-size: 1.77778rem;
    margin-left: 0;
    padding: 0.5rem 1rem;
    border-radius: 2px;
    text-align: center;
    border: 1px solid #eee;
    padding: 1rem;
  }
  ul {
    box-sizing: border-box;
    width: 100%;
    float: left;
    margin: 0;
    background: #fff;
    border: 1px solid #eee;
    border-top: none;
    border-radius: 2px;
    padding: 30px;

    li {
      padding: 5px 0;
    }
  }
`;

const StyledContent = styled.div`
  position: relative;
  width: calc(100% - 350px);
  height: calc(100% - 64px - 52px);
  float: left;
  background: white;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 50px;

  @-moz-document url-prefix() {
    height: 100%;
    min-height: 100%;
  }

  @media screen and (max-width: 800px) {
    width: 100%;
    min-height: calc(100% - 64px);
  }
`;

const StyledSignatureTab = styled.div`
  width: 100%;
  padding: 0 30px;
`;

const StyledSignatureHelp = styled.div`
  padding: 20px;
`;

const StyledSignature = styled.div`
  margin-top: 50px;
`;

const Signature = styled.div`
  width: 100%;
  height: auto;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
`;

const CopyNav = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 0 30px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const CopyToClipboardButton = styled.button`
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  border-radius: 2px;
  padding: 0.5rem 1rem;
  border: 1px solid #ccc;
  color: #333;
  cursor: pointer;
  background: none;
  outline: none;
  .copy-icon {
    margin-right: 10px;
    width: 18px;
  }
  span {
  }
`;

const CopyIcon = () => (
  <svg
    className="copy-icon"
    width="21"
    height="24"
    viewBox="0 0 21 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.341 3.09098L17.909 0.659016C17.4871 0.237058 16.9148 3.12036e-06 16.318 0L8.25 0C7.00734 0 6 1.00734 6 2.25V4.5H2.25C1.00734 4.5 0 5.50734 0 6.75V21.75C0 22.9927 1.00734 24 2.25 24H12.75C13.9927 24 15 22.9927 15 21.75V19.5H18.75C19.9927 19.5 21 18.4927 21 17.25V4.68197C21 4.08523 20.7629 3.51294 20.341 3.09098ZM16.5 1.52302C16.6319 1.55555 16.7523 1.62356 16.8483 1.71966L19.2803 4.15167C19.3764 4.24767 19.4444 4.36813 19.4769 4.5H16.5V1.52302ZM13.5 21.75C13.5 22.1635 13.1635 22.5 12.75 22.5H2.25C1.83647 22.5 1.5 22.1635 1.5 21.75V6.75C1.5 6.33647 1.83647 6 2.25 6H6V17.25C6 18.4927 7.00734 19.5 8.25 19.5H13.5V21.75ZM19.5 17.25C19.5 17.6635 19.1635 18 18.75 18H8.25C7.83647 18 7.5 17.6635 7.5 17.25V2.25C7.5 1.83647 7.83647 1.5 8.25 1.5H15V4.875C15 5.49375 15.5063 6 16.125 6H19.5V17.25Z"
      fill="black"
    />
  </svg>
);
